import { render } from "./InstallWizardShipping.vue?vue&type=template&id=03a58c0c"
import script from "./InstallWizardShipping.vue?vue&type=script&lang=js"
export * from "./InstallWizardShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__